import React from 'react'

const Error = () => {
  return (
    <div>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem, maiores adipisci! Quas odit sed impedit repellat corporis ea iste. Amet nisi obcaecati quibusdam ab cupiditate voluptate hic, qui beatae rerum iure incidunt fugiat ex, quidem vero nobis eum odio ipsa quae recusandae fugit sapiente libero eos! Sunt nostrum, saepe quae atque ratione qui nihil voluptatem sit exercitationem aliquid velit iusto nesciunt consequatur sint eaque expedita totam voluptate eos, eligendi quo! Ea repellat consectetur eveniet. Aliquid quos voluptatibus magni explicabo ab dicta, animi nobis eveniet earum totam, voluptatum consequuntur! Blanditiis excepturi est dolorem. Velit, ex consequuntur id accusantium minus reiciendis porro voluptas optio sint nobis hic, fugiat atque veritatis pariatur fuga dolore harum quam, doloremque debitis. Cupiditate deleniti beatae tempora optio consecteturerrrrrrrroorrrrrrr.
    </div>
  )
}

export default Error
